// Product Detail Page (PDP) JavaScript
(function () {
  // Wait for jQuery and DOM to be ready
  if (typeof jQuery === "undefined") {
    console.error("jQuery is required for product-pdp.js");
    return;
  }

  // Check if configuration is available
  if (
    typeof window.productPDPConfig === "undefined" ||
    !window.productPDPConfig.product
  ) {
    console.warn("Product PDP configuration not found");
    return;
  }

  const config = window.productPDPConfig;
  const product = config.product;
  const group_id = config.group_id;
  const moneyFormat = config.moneyFormat;
  const cache = {
    products: {},
  };

  function formatMoney(cents, format) {
    var value = "",
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || window.money_format || "$";

    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString?.match(placeholderRegex)?.[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString?.replace(placeholderRegex, value);
  }

  function scrollToReviews() {
    var reviews = document.getElementById("reviews-wrap");
    var header = document.getElementById("shopify-section-header");
    if (reviews && header) {
      var y =
        reviews.getBoundingClientRect().top +
        window.pageYOffset -
        header.clientHeight;
      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  }

  const mobilePhotos = document.querySelector(".product-single__carousel");
  let mobileSwiper = null;
  if (mobilePhotos && mobilePhotos.parentNode) {
    mobileSwiper = new Swiper(mobilePhotos.parentNode, {
      pagination: {
        el: mobilePhotos.parentNode.querySelector(".swiper-pagination"),
      },
    });
  }

  jQuery(document).ready(function ($) {
    $("body").append($(".product-image-modal"));

    $(".product-single__photos").on(
      "click",
      ".product-single__photo",
      function (e) {
        e.preventDefault();
        $(".product-image-modal__photos").slick(
          "slickGoTo",
          this.dataset.index,
          true
        );
        $(".product-image-modal").addClass("product-image-modal--open");
        scrollPosition =
          window.pageYOffset || document.documentElement.scrollTop;
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.width = "100%";
      }
    );

    $(".product-image-modal").on("click", function (e) {
      if (
        !$(e.target).closest(
          ".product-image-modal__photo, .product-image-modal__navigation"
        ).length
      ) {
        $(".product-image-modal").removeClass("product-image-modal--open");
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, scrollPosition);
      }
    });

    document.addEventListener("click", function (e) {
      if (
        e.target.closest(".pr-media-modal") &&
        !e.target.closest(".pr-media-card,.button")
      ) {
        var closeBtn = e.target
          .closest(".pr-media-modal")
          .querySelector(".button__close");
        if (closeBtn) {
          closeBtn.click();
        }
      }
    });

    buildPDP(product);
  });

  const pinchZoom = (imageElement) => {
    const minScale = 1;
    const maxScale = 4;

    const imageElementWidth = imageElement.offsetWidth;
    const imageElementHeight = imageElement.offsetHeight;

    let imageElementScale = 1;

    let rangeMaxX = 0;
    let rangeMinX = 0;

    let rangeMaxY = 0;
    let rangeMinY = 0;

    const updateRange = () => {
      const rangeX = Math.max(
        0,
        Math.round(imageElementWidth * imageElementScale) - imageElementWidth
      );
      const rangeY = Math.max(
        0,
        Math.round(imageElementHeight * imageElementScale) - imageElementHeight
      );

      rangeMaxX = Math.round(rangeX / 2);
      rangeMinX = Math.round(0 - rangeMaxX);

      rangeMaxY = Math.round(rangeY / 2);
      rangeMinY = Math.round(0 - rangeMaxY);
    };

    const updateImage = (deltaX, deltaY) => {
      const imageElementCurrentX =
        Math.min(Math.max(rangeMinX, deltaX), rangeMaxX) * 2;
      const imageElementCurrentY =
        Math.min(Math.max(rangeMinY, deltaY), rangeMaxY) * 2;

      const transform = `translate3d(${imageElementCurrentX}px, ${imageElementCurrentY}px, 0) scale(${imageElementScale})`;
      imageElement.style.transform = transform;
      imageElement.style.WebkitTransform = transform;
      imageElement.style.zIndex = "9999";
    };

    const resetImage = () => {
      imageElement.style.transform = "";
      imageElement.style.WebkitTransform = "";
      imageElement.style.zIndex = "";
    };

    imageElement.parentNode.style.overflow = "visible";
    imageElement.classList.add("pz-Image");

    const hammertime = new Hammer.Manager(imageElement, {
      touchAction: "auto",
      recognizers: [
        [
          Hammer.Pinch,
          {
            enable: true,
          },
        ],
      ],
    });

    hammertime.on("pinchstart", (event) => {
      console.log("pinchstart", event);
    });

    hammertime.on("pinchmove", (event) => {
      imageElementScale = Math.min(Math.max(minScale, event.scale), maxScale);
      updateRange();
      updateImage(event.deltaX, event.deltaY);
    });

    hammertime.on("pinchend", (event) => {
      console.log("pinchend", event);
      resetImage();
    });
  };

  function sendEvents(product) {
    if (window.location.pathname !== product.url) {
      history.replaceState(product, product.title, product.url);
      try {
        ga("send", "pageview");

        if (config.settings.dynamic_yield_enabled) {
          if (typeof DY.API != "undefined") {
            DY.API("event", {
              name: "Change Attribute",
              properties: {
                dyType: "change-attr-v1",
                attributeType: "Colour",
                attributeValue: product.variants[0].option1,
              },
            });

            DY.API("spa", {
              context: {
                type: "PRODUCT",
                data: [product.variants[0].sku],
              },
              url: product.url,
              countAsPageview: true,
            });

            DY.recommendationContext = {
              type: "PRODUCT",
              data: [product.variants[0].sku],
            };
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  }

let shareThisRetries = 0;

function loadShareThis(product) {
  try {
    if (
      (!window.__sharethis__ ||
        typeof window.__sharethis__.load !== "function") &&
      shareThisRetries++ < 50
    ) {
      return setTimeout(function () {
        loadShareThis(product);
      }, 100);
    }

    if (
      !window.__sharethis__ ||
      typeof window.__sharethis__.load !== "function"
    ) {
      return;
    }

    window.__sharethis__.load("inline-share-buttons", {
      image: product?.featured_image || "",
      title: product?.title || "",
      description: product?.description || "",
      url: `https://${window.location.host}${product?.url || ""}`,
    });
  } catch (err) {
    console.log("ShareThis error:", err);
  }
}

  function updateInStoreModal(product) {
    // dont have metafield data so just grab in store availability from the other page
    fetch(product.url)
      .then((resp) => resp.text())
      .then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        const storesContainer = document.querySelector(
          ".in-store-modal .stores"
        );
        const storesContent = div.querySelector(".in-store-modal .stores");
        if (storesContainer && storesContent) {
          storesContainer.innerHTML = storesContent.innerHTML;
        }
      })
      .catch((err) => {
        console.error("Error updating in-store modal:", err);
      });
  }

  function buildProductInfo(product) {
    // update product information on page
    const titleEl = document.querySelector(".product-single-title");
    if (titleEl && product?.title) {
      titleEl.innerText = product.title;
    } else {
      console.warn("Product title element not found or invalid data");
    }

    const descTitleEl = document.querySelector(
      ".acc__card--description .acc__title"
    );
    if (descTitleEl) {
      descTitleEl.innerText = "Product Details";
    }

    const descEl = document.querySelector(
      ".acc__card--description .product-description"
    );
    if (descEl && product?.description) {
      descEl.innerHTML = product.description;
    }
    var hasonsale = false,
      hasNoISPU = false,
      hasReleaseProduct = false,
      finalSaleTag = "none";
    if (product.tags.some((x) => x.toLowerCase() == "on-sale")) {
      hasonsale = true;
    }
    if (product.tags.some((x) => x.toLowerCase() == "final-sale")) {
      hasReleaseProduct = true;
    }
    if (product.tags.some((x) => x.toLowerCase() == "no-ispu")) {
      hasNoISPU = true;
    }

    // Get cart message variables from config
    const cartMessages = config.cartMessages || {};
    const cart_both = cartMessages.both || "";
    const cart_onSale = cartMessages.onSale || "";
    const cart_finalSale = cartMessages.releaseProduct || "";
    const cart_noIspu = cartMessages.noIspu || "";

    if (hasReleaseProduct && hasNoISPU) {
      finalSaleTag = cart_both;
    } else {
      if (hasonsale) {
        finalSaleTag = cart_onSale;
      } else if (hasReleaseProduct) {
        finalSaleTag = cart_finalSale;
      } else if (hasNoISPU) {
        finalSaleTag = cart_noIspu;
      }
    }
    const devLocalizationEl = document.querySelector(".dev-localization-text");
    if (devLocalizationEl) {
      if (finalSaleTag != "none") {
        devLocalizationEl.innerHTML = "<p>" + finalSaleTag + "</p>";
        devLocalizationEl.style.display = "block";
      } else {
        devLocalizationEl.style.display = "none";
      }
    }

    const priceEl = document.getElementById("ProductPrice");
    if (priceEl && product?.price) {
      priceEl.innerText = formatMoney(product.price, moneyFormat);
    }
    let comparePrice = document.getElementById("ComparePrice");
    if (product.compare_at_price_max) {
      if (!comparePrice) {
        comparePrice = document.createElement("p");
        comparePrice.id = "ComparePrice";
        document
          .querySelector(".product-single-price")
          .appendChild(comparePrice);
      }

      comparePrice.innerText = formatMoney(
        product.compare_at_price_max,
        moneyFormat
      );
    } else if (comparePrice) {
      comparePrice.remove();
    }
  }

  function setupReviews(product) {
    if (config.settings.reviews_enabled) {
      // re-render reviews
      pwr("render", {
        api_key: Theme.settings.reviews.api_key,
        locale: Theme.settings.reviews.locale,
        merchant_group_id: Theme.settings.reviews.group_id,
        merchant_id: Theme.settings.reviews.merchant_id,
        page_id: product.id,
        review_wrapper_url: `https://${window.location.host}/pages/write-a-review/?pr_page_id=${config.productId}`,
        on_back_to_top_click: scrollToReviews,
        on_read_reviews_click: function () {
          var reviews = document.getElementById("reviews-wrap");
          if (!reviews) return;
          var selected = document.querySelector(".acc__title.active");
          if (selected) {
            selected.classList.remove("active");
            if (selected.nextElementSibling) {
              selected.nextElementSibling.style.display = "none";
            }
          }
          const reviewsTitle = reviews.querySelector(".acc__title");
          const reviewsPanel = reviews.querySelector(".acc__panel");
          if (reviewsTitle) reviewsTitle.classList.add("active");
          if (reviewsPanel) reviewsPanel.style.display = "block";
          scrollToReviews();
        },
        product: {
          name: encodeURIComponent(product.title),
          url: `https://${window.location.host}${product.url}`,
          image_url: product.featured_image,
          description: encodeURIComponent(product.description),
          category_name: product.type != "" ? product.type : "Default",
          upc: "",
          brand_name: product.vendor,
          price: formatMoney(product.price, moneyFormat),
          in_stock: product.available,
          variants: product.variants.map((variant) => {
            return {
              name: variant.name,
              description: product.title,
              page_id_variant: variant.id,
              upc: variant.barcode,
            };
          }),
        },
        components: {
          ReviewDisplay: "pr-reviewdisplay",
          ReviewSnippet: "pr-reviewsnippet",
        },
      });
    }
  }

  function buildProductPhotos(product) {
    const $imageCarousel = $(".product-image-modal__photos");
    try {
      $imageCarousel.slick("unslick");
      $(".product-single__carousel").slick("unslick");
    } catch (e) {}

    const productPhotos = document.querySelector(".product-single__photos");
    productPhotos.innerHTML = "";
    mobilePhotos.innerHTML = "";

    const modalPhotos = document.querySelector(".product-image-modal__photos");
    modalPhotos.innerHTML = "";

    const style = product.tags
      .find((tag) => tag.includes("Style: "))
      ?.replace("Style: ", "");
    const category = product.tags
      .find((tag) => tag.includes("Category: "))
      ?.replace("Category: ", "");
    let alt = product.title;
    if (product.type === "Footwear" && (style || category)) {
      alt += " -";
      if (style) {
        alt += " " + style;
      }
      if (category) {
        alt += " " + category;
      }
    }
    const saleAmount =
      product.compare_at_price > product.price
        ? product.tags
            .find((tag) => tag.startsWith("OnSale-"))
            ?.replace("OnSale-", "")
        : 0;

    for (const [idx, media] of product.media.entries()) {
      productPhotos.innerHTML += `<a href="${Theme.getSizedImageUrl(
        media.src,
        "900x"
      )}" data-index="${idx}" class="grid__item one-half product-single__photo">
        ${
          idx == 1 && saleAmount
            ? `<div class="product__sale-badge product__sale-badge--right">${saleAmount}% off</div>`
            : ``
        }
        <img src="${Theme.getSizedImageUrl(media.src, "900x")}" alt="${
        alt + " " + idx
      }" loading="lazy">
      </a>`;
      mobilePhotos.innerHTML += `<div class="swiper-slide">${
        saleAmount
          ? `<div class="product__sale-badge">${saleAmount}% off</div>`
          : ``
      }<img src="${Theme.getSizedImageUrl(media.src, "900x")}" alt="${
        alt + " " + idx
      }" loading="lazy"></div>`;

      const modalImage = document.createElement("img");
      modalImage.src = Theme.getSizedImageUrl(media.src, "900x");
      modalImage.alt = media.alt;
      const modalPhoto = document.createElement("div");
      modalPhoto.classList.add("product-image-modal__photo");
      modalPhoto.dataset.index = idx;

      if (idx === 0 && product.tags.includes("size exclusive_Yes")) {
        modalPhoto.innerHTML = `<div class="product__exclusive">
            <div class="product__exclusive-tooltip">size? exclusive</div>
            <svg width="24" height="33" viewBox="0 0 24 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.20287 11.6696V10.7789C8.34217 8.2943 9.65903 6.74718 12.2346 6.74718C12.6264 6.71745 13.0201 6.76964 13.3907 6.90043C13.7613 7.03123 14.1005 7.23775 14.3869 7.50685C14.6733 7.77595 14.9005 8.10174 15.054 8.46347C15.2076 8.8252 15.2841 9.21494 15.2788 9.60787C15.2788 11.9531 13.4547 12.9365 11.5339 14.2476C9.79751 15.5128 7.7366 17.1075 7.7366 20.7622V23.105H15.1395C15.1862 20.2943 15.7951 19.592 18.2337 17.9974C21.7975 15.7464 24.0002 14.1066 24.0002 9.56117C24.0002 3.09244 18.1428 -0.000976562 12.2821 -0.000976562C4.97178 -0.000976562 0.0985214 4.26425 0.00100708 11.6688L8.20287 11.6696ZM7.76774 32.7778H15.1092V25.4486H7.76774V32.7778Z"
                fill="#FF600B" /></svg>
          </div>`;
      }

      modalPhoto.appendChild(modalImage);
      pinchZoom(modalImage);
      modalPhotos.appendChild(modalPhoto);
    }

    if (window.innerWidth <= 769 && mobileSwiper) {
      mobileSwiper.update();
    }

    $imageCarousel.slick({
      slidesToShow: 1,
      nextArrow:
        '<button type="button" class="product-image-modal__navigation product-image-modal__navigation--next slick-next"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0.804034L9.28332 9.5L0 18.196L0.858341 19L11 9.5L0.858341 0L0 0.804034Z" fill="white"/></svg></button>',
      prevArrow:
        '<button type="button" class="product-image-modal__navigation product-image-modal__navigation--prev slick-prev"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 18.196L1.71668 9.5L11 0.804035L10.1417 7.50386e-08L-8.30516e-07 9.5L10.1417 19L11 18.196Z" fill="white"/></svg></button>',
    });

    const swymButton = document.querySelector(
      ".pdp_add-to-favourites .swym-button"
    );
    if (swymButton && product?.id) {
      swymButton.dataset.productId = product.id;
      if (product.variants?.[0]?.id) {
        swymButton.dataset.variantId = product.variants[0].id;
      }
    }
    if (product?.id) {
      document.dispatchEvent(new CustomEvent("swym:variant-changed"));
    }
  }

  function buildSizeOptions(product) {
    Theme.sortVariantsBySize(product.variants);
    const sizeVariants = document.querySelector("[data-size-options]");
    if (!sizeVariants) {
      console.warn("Size options container not found");
      return;
    }
    sizeVariants.innerHTML = "";
    const sizeHeaderName = document.querySelector(
      ".pdp__options--size .header .name"
    );
    if (sizeHeaderName) {
      const sizeType = product.tags?.find((tag) =>
        tag.startsWith("Size Type_")
      );
      if (sizeType) {
        sizeHeaderName.innerText = `Pick your ${sizeType.replace(
          "Size Type_",
          ""
        )}`;
      } else if (config.translations?.size) {
        sizeHeaderName.innerText = `Pick your ${config.translations.size}`;
      }
    }

    const isUnisex = product.tags.find(
      (tag) => tag === "Gender Designation_Unisex"
    );
    const isMens = product.tags.find(
      (tag) => tag === "Gender Designation_Mens"
    );
    const sizeWomens = product.tags.find(
      (tag) => tag === "Gender Designation_Womens"
    );
    const sizeUnisex =
      isUnisex &&
      product.tags.find((tag) => tag === "Hierarchy Group_Footwear");
    const sizeApparel =
      product.tags.find((tag) => tag === "Department_Mens Apparel") ||
      "Department_Womens Apparel";
    const brandOffset = config.brandOffset;
    const isMensOffset = product.tags.find(
      (tag) => tag === "Gender Designation-Mens"
    );
    const isWomensSizes = product.tags.find(
      (tag) => tag === "Gender-Womens-Sizes"
    );
    const offset = +product.tags
      .find((tag) => tag.includes("size_offset_"))
      ?.replace("size_offset_", "");

    for (const variant of product.variants) {
      const elm = document.createElement("div");
      elm.classList.add("swatch-element");
      let text = variant.option2;

      // Check if product is out of stock, is footwear/apparel, has multiple sizes
      if (!variant.available && product.variants.length > 1) {
        let pType = product.type;
        if (
          checkSizeValue(
            text,
            isMens,
            sizeWomens,
            sizeUnisex,
            pType,
            sizeApparel
          )
        ) {
          continue;
        }
      }
      if (offset && product.type === "Footwear" && !isNaN(text)) {
        if (isMensOffset) {
          text = `M ${text} / W ${text * 1 + offset}`;
        } else if (isWomensSizes) {
          text = `M ${text * 1 - offset} / W ${text}`;
        }
      }

      elm.innerHTML = `
          <input id="swatch-1-${
            variant.option2
          }" type="radio" name="id" value="${variant.id}" data-sku="${
        variant.sku
      }" data-size="${variant.option2}">
          <label for="swatch-1-${variant.option2}">
            ${text}
            <img class="crossed-out" style="opacity: 0.5" src="//cdn.shopify.com/s/files/1/0519/9606/5960/t/54/assets/close.svg?v=8798068499958462156" loading="lazy">
          </label>
          ${
            variant.available
              ? ""
              : "<div class='swatch-element__option-tooltip'>Waitlist</div>"
          }`;

      if (variant.available) {
        elm.classList.add("available");
      } else {
        elm.classList.add("soldout");
        elm.querySelector("input").classList.add("soldout");
      }

      sizeVariants.appendChild(elm);
    }

    if (product.variants.length > 1) {
      sizeVariants.addEventListener("change", function (e) {
        jQuery(".error-state").addClass("hide");
        if (e.target.tagName === "INPUT") {
          if (e.target.classList.contains("soldout")) {
            e.preventDefault();
            _backInStockModal(e.target.value, product);
            const ctmBtn = document.querySelector(".ctm_btn_trigger");
            const bisBtn = document.querySelector(".btn.bis-modal");
            if (ctmBtn) ctmBtn.classList.add("hide");
            if (bisBtn) bisBtn.classList.remove("hide");
          } else {
            const bisBtn = document.querySelector(".btn.bis-modal");
            const ctmBtn = document.querySelector(".ctm_btn_trigger");
            const swymBtn = document.querySelector(
              ".pdp_add-to-favourites .swym-button"
            );
            if (bisBtn) bisBtn.classList.add("hide");
            if (ctmBtn) ctmBtn.classList.remove("hide");
            if (swymBtn && e.target.value) {
              swymBtn.dataset.variantId = e.target.value;
            }
            document.dispatchEvent(new CustomEvent("swym:variant-changed"));

            try {
              DY.API("event", {
                name: "Change Attribute",
                properties: {
                  dyType: "change-attr-v1",
                  attributeType: "Size",
                  attributeValue: e.target.dataset.size,
                },
              });

              DY.recommendationContext = {
                type: "PRODUCT",
                data: [e.target.dataset.sku],
              };
            } catch (err) {
              console.error(err);
            }
          }
        }
      });
    } else {
      const input = sizeVariants?.querySelector("input");
      if (input) {
        input.click();
      }
    }
  }

  function _backInStockModal(id, product) {
    const modal = document.querySelector(".modal--back-in-stock");
    if (!modal) {
      console.warn("Back in stock modal not found");
      return;
    }
    modal.classList.add("modal--open");
    const select = modal.querySelector("[data-variant-selector]");
    if (!select) {
      console.warn("Variant selector not found in modal");
      return;
    }
    select.innerHTML = "";

    for (const variant of product.variants) {
      if (!variant.available) {
        const option = document.createElement("option");
        option.value = variant.id;
        option.innerText = variant.option2;
        select.appendChild(option);
      }
    }

    if (id) {
      select.value = id;
    }

    const backInStockEl = modal.querySelector(".back-in-stock");
    const backInStockSuccessEl = modal.querySelector(".back-in-stock-success");
    if (backInStockEl) backInStockEl.style.display = "block";
    if (backInStockSuccessEl) backInStockSuccessEl.style.display = "none";
  }

  function buildFinalSaleNotice(product) {
    const finalSaleTag = product.tags.find(
      (tag) => Theme.settings.final_sale[tag]
    );
    const finalSaleEl = document.querySelector("[data-final-sale-text]");
    if (finalSaleEl) {
      if (finalSaleTag && Theme.settings?.final_sale?.[finalSaleTag]) {
        finalSaleEl.classList.add("final-sale-text");
        finalSaleEl.innerHTML =
          '<p class="final-sale">' +
          Theme.settings.final_sale[finalSaleTag] +
          "</p>";
      } else {
        finalSaleEl.innerHTML = "";
      }
    }
  }

  function buildBackInStock(product) {
    $(".bis-modal").on("click", function (e) {
      e.preventDefault();
      var form = $("#AddToCartForm");
      var id = $(form).find('input[name="id"]:checked').val();
      _backInStockModal(id, product);
    });
  }

  function buildLimitQuantityMessage(product) {
    const limitQuantityElement = document.querySelector(
      "form .pdp__add-to-cart"
    );

    if (!limitQuantityElement) return;

    const errorMessage = document.querySelector(".limit-quantity-error");

    if (product.tags.includes("limit-quantity")) {
      if (!errorMessage) {
        const newErrorMessage = document.createElement("p");
        newErrorMessage.innerText = config.translations.limited_qty;
        newErrorMessage.classList.add("limit-quantity-error");
        limitQuantityElement.insertAdjacentElement("afterend", newErrorMessage);
      }
      limitQuantityElement.setAttribute("data-product-limit", "true");
    } else {
      if (errorMessage) errorMessage.remove();
      limitQuantityElement.setAttribute("data-product-limit", "false");
    }

    limitQuantityElement.setAttribute("data-product-id", product.id);
  }

  function buildPDP(product) {
    product.url = Theme.routes.products + "/" + product.handle;
    sendEvents(product);
    loadShareThis(product);
    updateInStoreModal(product);
    buildProductInfo(product);
    setupReviews(product);
    buildProductPhotos(product);
    buildSizeOptions(product);
    buildLimitQuantityMessage(product);
    buildFinalSaleNotice(product);
    buildBackInStock(product);
    const event = new Event("buildPDP");
    document.dispatchEvent(event);
  }

  function checkSizeValue(size, mens, womens, unisex, pType, apparelSize) {
    if (pType.toLowerCase() === "apparel") {
      if (apparelSize) {
        let intValue = parseInt(size.slice(0, 1).trim());
        if (size.includes("XS") && /\d/.test(size)) {
          return true;
        }
        if (!isNaN(intValue) && intValue > 2 && size.includes("XLRG")) {
          return true;
        }
      }
    }

    if (pType.toLowerCase() === "footwear") {
      let number = parseFloat(size);
      // Check size range based on gender specifications.
      if (unisex || (unisex && mens && womens)) {
        if (number < 4 || number > 13) {
          return true;
        }
      } else if (mens) {
        if (number < 7 || number > 13) {
          return true;
        }
      } else if (womens) {
        if (number < 6 || number > 10) {
          return true;
        }
      }
    }
  }

  if (group_id) {
    const colourOptions = document.querySelector("[data-colour-options]");
    if (!colourOptions) {
      console.warn("Colour options container not found");
      return;
    }
    colourOptions.addEventListener("change", (e) => {
      let elm = e.target;
      if (!elm.classList.contains("pdp__option-input")) {
        elm = elm.closest(".pdp__option-input");
      }

      if (elm && elm.classList.contains("pdp__option-input")) {
        const handle = elm.value;
        buildPDP(cache.products[handle]);
      }
    });

    Theme.getProductGroup(group_id)
      .then(function (products) {
        const colourOptionsEl = document.querySelector("[data-colour-options]");
        if (colourOptionsEl) {
          colourOptionsEl.innerHTML = "";
        }
        products.forEach((product) => {
          cache.products[product.handle] = product;
          const productOption = document.createElement("div");
          productOption.classList.add("pdp__option");
          productOption.dataset.handle = product.handle;
          productOption.innerHTML = `<input id="variant-color-${
            product.id
          }" data-color-option="${
            product.variants[0].option1
          }" class="pdp__option-input visually-hidden" type="radio" name="option1" value="${
            product.handle
          }" />
              <label for="variant-color-${
                product.id
              }" class="pdp__option-label">
                <img src="${Theme.getSizedImageUrl(
                  product.media[0].preview_image.src,
                  "200x"
                )}" alt="${product.title}" loading="lazy" />
              </label>`;
          if (colourOptionsEl) {
            colourOptionsEl.append(productOption);
          }
        });

        const pdpSection = document.querySelector("[data-pdp-section]");
        if (pdpSection) {
          var handle = pdpSection.getAttribute("data-pdp-section");
          const colorOption = document.querySelector(
            "[data-color-option][value='" + handle + "']"
          );
          if (colorOption) {
            colorOption.click();
          }
        }

        return products;
      })
      .catch((err) => {
        console.error(err);
      });
  } else {
    const colorOptionsEl = document.querySelector(".pdp__options--color");
    if (colorOptionsEl) {
      colorOptionsEl.innerHTML = "";
    }
  }
})();
